var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchBox"},[_c('div',{staticClass:"formBox"},[_vm._t("form")],2),_c('div',{staticClass:"btnBox"},[_vm._t("btns")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }